export type BudgetReportRequest = {
  pageNumber: number;
  pageSize: number;
  filter: budgetFilter;
};

export type budgetFilter = {
  budgetYear: number;
  description: string;
  costCenter: string;
  glAccount: string;
  internalOrder: string;
  glName: string;
};

export type BudgetReportSummary = {
  BudgetYear: string;
};

export const GetReportBudget = async (
  req: BudgetReportRequest
): Promise<any> => {
  const res = await fetch("api/Budget/GetReportBudget", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
  })
    .then((response) => response.json())
    .then((data) => {
      const monthOrder = [
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
      ];

      const sortedData = data?.reportData?.map((level1: { children: any[]; }) => {
        return {
          ...level1,
          children: level1.children?.map(level2 => {
            return {
              ...level2,
              children: level2.children
                ?.slice()
                .sort((a: { desc: string; }, b: { desc: string; }) => {
                  const monthA = a.desc?.split(" - ")[0]?.trim() ?? "";
                  const monthB = b.desc?.split(" - ")[0]?.trim() ?? "";
                  return monthOrder.indexOf(monthA) - monthOrder.indexOf(monthB);
                })
            };
          })
        };
      });


      return { data, ...{ reportData: sortedData } };
    })
    .catch((err) => {

    });
  return res;
};

export const GetReportBudgetSummaries = async (req: BudgetReportRequest) => {
  const res = await fetch("api/Budget/GetBudgetTrackingIOSummaries", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ Filter: req }),
  }).then((r) => r.json());
  return res;
};

export const GetReportBudgetFilter = async (budgetYear: number): Promise<any> => {
  const result = await fetch("api/Budget/GetOptionReport", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      pageNumber: 1,
      pageSize: 10,
      filter: {
        budgetYear: budgetYear,
        description: "",
        costCenter: "",
        glAccount: "",
        glName: "",
        internalOrder: "",
      },
    })
  })
    .then((r) => r.json()).then((data) => {
      const monthOrder = [
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
      ];
      const responseFilter = data?.io.sort((a: { label: string; }, b: { label: string; }) => {
        const monthA = a.label?.split(" - ")[0]?.trim() ?? "";
        const monthB = b.label?.split(" - ")[0]?.trim() ?? "";
        return monthOrder.indexOf(monthA) - monthOrder.indexOf(monthB);
      })
      data.io = responseFilter;
      return data;
    }).catch((err) => {
      return {
        cost: [],
        gl: [],
        io: [],
        year: [],
        gl_name: [],
      }
    });

  return result;
};

export const GetPermissionReport = async (req: BudgetReportRequest) => {
  const res = await fetch(
    `api/Budget/GetPermissionReport?BudgetYear=${req.filter.budgetYear}`
  ).then((r) => r.json());
  return res;
};

export const GetViewAutoBudgetDepartment = async (
  req: BudgetReportSummary
): Promise<any> => {
  const res = await fetch("api/Budget/GetViewAutoBudgetDepartment", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
  }).then((r) => r.json());

  return res;
};

export const GetViewAutoBudgetMonthly = async (
  req: BudgetReportSummary
): Promise<any> => {
  const res = await fetch("api/Budget/GetViewAutoBudgetMonthly", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
  }).then((r) => r.json());

  return res;
};

export const GetViewAutoBudgetExpenseControl = async (
  req: BudgetReportSummary
): Promise<any> => {
  const res = await fetch("api/Budget/GetViewAutoBudgetExpenseControl", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
  }).then((r) => r.json());

  return res;
};
export const GetYearBudget = async (req: any): Promise<any> => {
  const res = await fetch("api/Budget/GetYearBudget", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
  }).then((r) => r.json());

  return res;
};
